import type { Optional } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import type { ValueConfig } from '../../types/templateModel'
import { isComparisonUnchanged } from '../fplusDiff/diffModel'
import { DiffEntry } from './DiffEntry'
import { useHideInheritanceDiff } from './useHideInheritanceDiff'

type Props = {
  current: Optional<ValueConfig>
  compare: Optional<ValueConfig>
}

/**
 * Type config is a single short value, where a diff would add noise rather than
 * information, so it keeps the before-beside-after presentation.
 */
export const SimpleTemplateFieldConfigDiff = ({ current, compare }: Props) => {
  const translate = useTranslate()
  const isHidingInheritanceDiff = useHideInheritanceDiff(current)

  if (isComparisonUnchanged(compare, current) || isHidingInheritanceDiff) {
    return null
  }

  return (
    <DiffEntry
      title={translate('diffPopover.field.config')}
      compare={compare}
      current={current}
    />
  )
}
